import {FC} from 'react';
import {IonButton, IonRouterLink} from '@ionic/react';

type UIButtonProps = {
  type: ('full' | 'full-white' | 'outline' | 'link');
  text: string;
  buttonType?: ('button' | 'reset' | 'submit');
  color?: string;
  style?: string;
  onClick?: Function;
  link?: string;
}

const UIButton: FC<UIButtonProps> = ({type, buttonType = 'button', text, style, onClick, link, color}) => {
  if (type === 'full') {
    return (
      <IonButton
        onClick={() => onClick && onClick()}
        type={buttonType}
        color={color}
        expand="block"
        className={`h-14 md:h-12 md:round-10 normal-case ${style}`}
      >{text}</IonButton>
    );
  } else if (type === 'full-white') {
    return (
      <button
        type={buttonType}
        onClick={() => onClick && onClick()}
        className={`font-semibold 17 font-Manrope button 
        button-block button-solid ion-activatable ion-focusable bg-white rounded-20 w-full h-16`}
      >{text}</button>
    );
  } else if (type === 'link') {
    return (
      <IonRouterLink
        routerLink={link}
        className={`text-white ${style ? style : 'py-2 px-10 rounded-lg bg-navy-primary'}`}
      >{text}</IonRouterLink>
    );
  }
  return (
    <button
      type={buttonType}
      onClick={() => onClick && onClick()}
      className={`${style ? `${style}` : 'text-md text-navy-primary'} font-Outline font-normal underline`}
    >{text}</button>
  );
};

export default UIButton;
